import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addSurveyMiddle, editSurveyMiddle } from "store/actions";
import { withTranslation } from "react-i18next";

import { fetchLanguageList } from "helpers/backend_api_helper";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchSurveyMiddleListData } = props
    const [surveyMiddleData, setSurveyMiddleData] = useState();
    const [languageList, setLanguageList] = useState()
    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.configSurveyMiddle.loading,
        error: state.configSurveyMiddle.error,
        success: state.configSurveyMiddle.success,
        editLoading:state?.configSurveyMiddle?.editLoading
    }));
    const dispatch = useDispatch();
    const [textTemplate, setTextTemplate] = useState(surveyMiddleData?.text)


    useEffect(() => {
        setSurveyMiddleData(itemData)
    }, [itemData])
    // fetch language
    const fetchLanguageLists = async () => {
        const listLang = await fetchLanguageList();
        setLanguageList(listLang?.data)
    }

    useEffect(() => {
        fetchLanguageLists()
    }, [])


    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            text: surveyMiddleData?.text || '',
            language_id: surveyMiddleData?.language_id || languageList && languageList[0]?.id,
            is_active: surveyMiddleData?.is_active || 'Y'
        },
        validationSchema: Yup.object({

            language_id: Yup.string().required(`${props.t("Please Enter Your Language")}`),
            is_active: Yup.string().required(`${props.t("Please Enter Language Status")}`),
        }),
        onSubmit: (values, { resetForm, setFieldValue }) => {
            if(!textTemplate){
                toastr.error(props.t("Please Enter Your Welcome Text"))

            }

            values = {
                ...values,
                text: textTemplate
            }

            if (isEdit) {
                dispatch(editSurveyMiddle(values, surveyMiddleData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            text: '',
                            language_id: '',
                            is_active: 'Y'
                        });
                        fetchSurveyMiddleListData()
                        setTextTemplate()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        setTextTemplate()
                        toggle()
                        

                    }
                }));
            } else {
                dispatch(addSurveyMiddle(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            text: '',
                            language_id: '',
                            is_active: 'Y'
                        });
                        fetchSurveyMiddleListData()
                        setTextTemplate()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        setTextTemplate()
                        toggle()
                        
                    }
                }));
            }

        }
    });
    const editorConfiguration = {
        placeholder: props.t("Enter Text"),
        toolbar: ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript']

      };



    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    setTextTemplate()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        setTextTemplate()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Middle Text") : props.t("Add Middle Text")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language")}:</Label>
                            <Input
                                name="language_id"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.language_id || ""}
                                invalid={
                                    validation.touched.language_id && validation.errors.language_id ? true : false
                                }
                            >
                                <option value="" disabled>{props.t("Select Language")}</option>
                                {
                                    languageList?.map((data, key) => {
                                        return (
                                            <option key={key} value={data?.id}>{data?.label}</option>
                                        )
                                    })
                                }
                            </Input>
                            {validation.touched.language_id && validation.errors.language_id ? (
                                <FormFeedback type="invalid">{validation.errors.language_id}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Middle Text")}:</Label>
                            <CKEditor
                                config={editorConfiguration}
                                editor={ClassicEditor}
                                data={surveyMiddleData?.text ? surveyMiddleData?.text : ""}
                                onChange={(event, editor) => {
                                const data = editor.getData();
                                    setTextTemplate(data)
                                }}
                            />
                        </div>

                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y'}
                                    value="Y"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N'}
                                    value="N"
                                    type="radio"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(AddEditModal);

